const TERMS_CONSENT_KEY = 'tq_terms_accepted';
export const TERMS_CONSENT_EVENT = 'tq:terms-consent-changed';

const canUseBrowser = () => typeof window !== 'undefined';

const notifyTermsConsentChange = (accepted) => {
  if (!canUseBrowser()) return;

  window.dispatchEvent(
    new CustomEvent(TERMS_CONSENT_EVENT, {
      detail: { accepted },
    })
  );
};

export const getStoredTermsConsent = () => {
  if (!canUseBrowser()) return false;

  return window.localStorage.getItem(TERMS_CONSENT_KEY) === 'true';
};

export const setStoredTermsConsent = (value) => {
  if (!canUseBrowser()) return;

  if (value) {
    window.localStorage.setItem(TERMS_CONSENT_KEY, 'true');
    notifyTermsConsentChange(true);
    return;
  }

  window.localStorage.removeItem(TERMS_CONSENT_KEY);
  notifyTermsConsentChange(false);
};

export const hasAcceptedTerms = () => getStoredTermsConsent();
